import { NavLink } from 'react-router-dom';
import { useLocation } from 'react-router';
import s from './AuthNav.module.css';

export default function AuthNav() {
  const location = useLocation();
  return (
    location.pathname !== '/verification' && (
      <div>
        <NavLink
          to="/register"
          exact
          className={s.link}
          activeClassName={s.activeLink}
        >
          Registration
        </NavLink>
        <NavLink
          to="/login"
          exact
          className={s.link}
          activeClassName={s.activeLink}
        >
          Log In
        </NavLink>
      </div>
    )
  );
}
